import 'whatwg-fetch';

const shouldUseKvConfigDomain = document.location.hostname === 'localhost'
  || document.location.hostname.includes("192.168")
  || document.location.hostname.includes("bs-local.com") //browserstack
  || window.location.href.includes("testprod")
  || document.kvConfig.isWordpressPlugin;

export const HOST_NAME = document.kvConfig.domain && shouldUseKvConfigDomain
    ? document.kvConfig.domain : "";

export function handleHttpError(response) {
    if (response.status === 400) { // bad request
        return response.json()
            .then(json => {
                checkApiError(json);
                //console.log(400, json);
                return Promise.resolve({__error__: true});
            });
    }

    if (!response.ok) {
        return response.json()
            .then(json => Promise.reject(json ? json.message : response.statusMessage));
    }

    return response;
}

function checkApiError(response) {
    let errorMessage = response.error || response.errorMessage
        || (response.errors && Array.isArray(response.errors) ? response.errors.join(',') : null);
    if (!errorMessage) {
        return;
    }

    //dispatch({type: ActionTypes.HTTP_ERROR, payload: errorMessage});
}

export function getResponse(response) {
    if (!response)
        return null;
    if (response.json)
        return response.json();
    return response;
}


export const get = (url) => {
    return fetch(HOST_NAME + url, {
    // return fetch('http://localhost:3000/localdata', {
        headers: {
            'Accept': 'application/json'
        }
    })
        .then(handleHttpError)
        .then(response => getResponse(response))
        .catch(reason => Promise.reject(reason));
};

export const post = (url, data, { signal, domain } = {}) => {
  const isFormData = Object.prototype.toString.call(data) === '[object FormData]';
  const headers = {
    'Accept': 'application/json'
  };
  if (!isFormData) {
    headers['Content-Type'] = 'application/json';
  }

  return fetch(domain ? domain + url : HOST_NAME + url, {
    method: 'post',
    body: isFormData ? data : JSON.stringify(data),
    headers: new Headers(headers),
    signal: signal,
  })
    .then(handleHttpError)
    .then(response => getResponse(response))
    .catch(reason => {
      if (reason.name === 'AbortError') {
        console.log('Fetch aborted');
      } else {
        return Promise.reject(reason);
      }
    });
};
